import React, { useEffect } from 'react';
import {
  Box,
  Text,
  Stack,
  Flex,
  Image,
  Center,
  Spinner,
  Icon,
  Progress,
  Button,
} from '@chakra-ui/react';
import ReactGA from 'react-ga';
import NumberFormat from 'react-number-format';
import { useHistory } from 'react-router-dom';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { useUserOwnedVestingInfo, getAddrState, useStreamInfo } from '../../api/query';

import { tokenMap } from '../../config/constants';
import Panel from '../../components/panel';
import userStore from '../../stores/account';

import fundingSvg from '../../assets/funding.svg';
// import {

// } from '../../api/contracts';
// import { useAssetsQuery } from '../../api/query';

const Page = () => {
  const address = getAddrState();
  const { isLoading, data: vestings = [] } = useUserOwnedVestingInfo(
    '0xCea5E66bec5193e5eC0b049a3Fe5d7Dd896fD480',
  );

  useEffect(() => {
    ReactGA.pageview('/myVesting');
  }, []);

  const history = useHistory();

  const renderVestingItem = (data: any, idx: number) => {
    const {
      id,
      streamId,
      tokenAddress,
      erc721Address,
      sender,
      deposit = 0,
      balance = 0,
      claimed,
      startTime,
      stopTime,
    } = data;
    const { token, imgUrl, name } = tokenMap[tokenAddress.toLowerCase()];
    console.log(data);
    return (
      <Stack
        h="100px"
        w="100%"
        key={idx}
        borderBottom="1px solid #EEEEEE"
        py={2}
        direction="row"
        cursor="pointer"
        _hover={{ bg: '#fafcfe' }}
        onClick={() => {
          // history.push(`/vesting/${streamId}`);
        }}
        spacing={0}
      >
        <Flex w="100%">
          <Image h="80px" w="80px" src={imgUrl} borderRadius="10px" />
          <Stack w="100%" ml={4}>
            <Text textStyle="title" minH="18px">
              {`${name} #${streamId}`}
            </Text>
            <Flex w="100%" justifyContent="space-between" mb={1}>
              <Text as="div" textStyle="label" mb={-1} fontWeight="bold">
                Supplies:{' '}
                <NumberFormat
                  value={balance}
                  displayType={'text'}
                  thousandSeparator={true}
                  renderText={(value) => {
                    const numArr = value.split('.');
                    return (
                      <>
                        {numArr[0]}
                        {numArr[1] && (
                          <Text as="span" fontSize="12px">
                            .{numArr[1]}
                          </Text>
                        )}
                      </>
                    );
                  }}
                />
              </Text>
              <Text as="div" fontSize="12" textColor="#999999" mb={-1} fontWeight={400}>
                {`${startTime} ~ ${stopTime}`}
              </Text>
            </Flex>
            <Box pos="relative">
              <Flex zIndex={10}>
                <Progress
                  h="24px"
                  w="100%"
                  borderRadius="20px"
                  colorScheme={'vesting'}
                  value={(Number(balance) / Number(deposit)) * 100}
                  bgColor="#999999"
                />
                <Button
                  w="100px"
                  ml={4}
                  borderRadius="20px"
                  size="xs"
                  fontSize="14px"
                  fontWeight="bold"
                >
                  VESTING
                </Button>
              </Flex>
              <Flex zIndex={20} top={0} pos="absolute" w="85%" justifyContent="space-between">
                <Flex>
                  <Image mr={2} w="24px" h="24px" src={fundingSvg} />
                  <Text fontSize="16px" fontWeight="bold" textColor="white" lineHeight="24px">
                    Balance:
                    <NumberFormat
                      value={balance}
                      displayType={'text'}
                      thousandSeparator={true}
                      renderText={(value) => {
                        const numArr = value.split('.');
                        return (
                          <>
                            {numArr[0]}
                            {numArr[1] && (
                              <Text as="span" fontSize="12px">
                                .{numArr[1]}
                              </Text>
                            )}
                          </>
                        );
                      }}
                    />
                  </Text>
                </Flex>
                <Text fontSize="16px" fontWeight="bold" textColor="white" lineHeight="24px">
                  Claimed:
                  <NumberFormat
                    value={claimed}
                    displayType={'text'}
                    thousandSeparator={true}
                    renderText={(value) => {
                      const numArr = value.split('.');
                      return (
                        <>
                          {numArr[0]}
                          {numArr[1] && (
                            <Text as="span" fontSize="12px">
                              .{numArr[1]}
                            </Text>
                          )}
                        </>
                      );
                    }}
                  />
                </Text>
              </Flex>
            </Box>
          </Stack>
        </Flex>
        {/* <Box w="40%">
          <Box h="45px"></Box>
          <Text textStyle="value">
            <Text as="div" textStyle="label" mb={-1}>
              Claimed ({token})
            </Text>
            <NumberFormat value={0} displayType={'text'} thousandSeparator={true} />
              </Text>
            </Box>
            <Box w="20%" textAlign="right">
              <Box h="45px"></Box>
              <Text textStyle="num">
                <Text as="div" textStyle="label" mb={-1}>
                  Claimable ({token})
                </Text>
                <NumberFormat value={0} displayType={'text'} thousandSeparator={true} />
              </Text>
            </Box> */}
        <Box w="20px">
          <Box h="40px"></Box>
          <Box>
            <Icon w="24px" h="36px" as={ChevronRightIcon} />
          </Box>
        </Box>
      </Stack>
    );
  };

  return (
    <Panel mt={4}>
      <Flex justifyContent="space-between">
        <Text textStyle="title">My investment</Text>
        <Text
          textStyle="title"
          textColor="primary"
          cursor="pointer"
          onClick={() => history.push('/addVesting')}
        >
          CREATE NEW PROJECT
        </Text>
      </Flex>
      {isLoading ? (
        <Center h="80%">
          <Spinner />
        </Center>
      ) : (
        <Stack mt={4}>
          {vestings.length > 0 ? (
            vestings.map((d: any, idx: number) => {
              return renderVestingItem(d, idx);
            })
          ) : (
            <Center minH="500px" h="80%">
              There is no project yet. Kick start your own vesting pool now!
            </Center>
          )}
        </Stack>
      )}
    </Panel>
  );
};

export default Page;
